import { default as Logo_ } from '../assets/logo/VF_logo_linear_grey_RGB.svg';
import { styled } from '../stitches.config';

export const Logo = styled(Logo_);
